import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const OptionsSection = () => {
  return (
    <section className="options">
      <Container fluid="lg">
        <Row className="list">
          <Col className="item">
            <h1>
              Si eres una entidad, colectivo o espacio sociocultural
            </h1>
            <p>
              Colaboro como tallerista en la Asociación de Cultura Menstrual “La Vida en Rojo”. Desde esta entidad, impulsamos y desarrollamos actividades educativas orientadas a la transformación sociocultural y política en torno a las distintas etapas vitales de las mujeres y personas menstruantes y menopáusicas.
            </p>
          </Col>
          <Col className="item">
            <h1>
              Si trabajas en un medio de comunicación, editorial o proyecto audiovisual
            </h1>
            <p>
              Contáctame para entrevistas, reportajes o espacios de divulgación sobre educación menstrual, perimenopausia y menopausia, desde una perspectiva social, feminista y de derechos.
            </p>
          </Col>
          <Col className="item">
            <h1>Si formas parte de una administración pública, entidad social, sindicato o proyecto colectivo</h1>
            <p>
              Aporto experiencia en guías, planes y estrategias sobre educación menstrual, perimenopausia y menopausia, combinando incidencia, asesoría y coordinación con organizaciones.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default OptionsSection;
